const MONTH_YEAR = /(january|february|march|april|may|june|july|august|september|october|november|december)\s+\d{4}/i;

const slugify = (t) => (t || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 70);

export const issueSlug = (e) => {
  const m = `${e.month || ''} ${e.title || ''}`.match(MONTH_YEAR);
  return slugify(m ? m[0] : e.title || e.month);
};

export const shareUrl = (e) => `${window.location.origin}/api/share/issue/${issueSlug(e)}`;
